<template>
    <section v-if="CurrentBanner" class="c-banner u-pos-relative">
        <div class="c-banner-content">
            <strong class="c-banner__title u-h2 u-font-italic u-font-weight-medium" v-if="CurrentBanner.Name">
                {{ CurrentBanner.Name }}
            </strong>            
            <a :href="CurrentBanner.Hyperlink" class="c-button c-button--alpha" v-if="CurrentBanner.Hyperlink">{{ CurrentBanner.CTAText }}</a>
        </div>
        <img :src="CurrentBanner.Image">
    </section>
</template>

<script>
    import Vue from 'vue'

    // Store
    import {mapGetters} from 'vuex'

    export default {        
        props: {
            location: String
        },
        components: {},
        data() {
            return {
            }
        },
        methods: {},
        created() {
            this.$store.dispatch('getCurrentBanner', this.location).then(() => {

            })
        },
        computed: {
            ...mapGetters({
                CurrentBanner: 'CurrentBanner',
            })
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-banner--commercial {
        position: relative;

        &:after {
            content: '';
            right: 0;
            top: 0;
            height: 100%;
            width: 50%;
            position: absolute;
            background-image: linear-gradient(to right, rgba(white, 0), rgba(white, .8));
        }

        .c-banner-content {
            top: em(-$global-spacing-unit-tiny);
            right: 0;
            height: 100%;
            position: absolute;
            z-index: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-right: em($global-spacing-unit);
            align-items: flex-end;
        }

        .c-button {
            padding-left: em($global-spacing-unit-medium);
            padding-right: em($global-spacing-unit-medium);
        }
    }


</style>


// WEBPACK FOOTER //
// src/components/banners/Banner.vue